'use client';

import { cn } from '@core/utils';

export { AD_SLOT_DEBUG_PLACEHOLDER_ENABLED } from '@/constants/ad';

interface AdSlotDebugPlaceholderProps {
  width: number;
  height: number;
  rounded?: 'medium' | 'large';
  className?: string;
}

export const AdSlotDebugPlaceholder = ({
  width,
  height,
  rounded = 'large',
  className,
}: AdSlotDebugPlaceholderProps) => (
  <div
    aria-hidden
    data-ad-debug-placeholder
    className={cn(
      'pointer-events-none flex-col gap-4 border border-dashed border-Gray-300 bg-Gray-100 text-Gray-500 flex-center',
      rounded === 'medium' ? 'rounded-medium' : 'rounded-large',
      className,
    )}
    style={{
      width: `min(100%, ${width}px)`,
      aspectRatio: `${width} / ${height}`,
    }}
  >
    <span className="font-700 typo-caption1">AD</span>
    <span className="font-500 typo-caption2">개발용 광고 영역</span>
  </div>
);
